/* Nordic Aim — jämnar ut produktkorten RAD FÖR RAD i stället för globalt.
 *
 * Bakgrund: betygsraden och prisblocket reserverade fast höjd på varje kort, så att
 * pris, lagerstatus och köpknapp skulle linjera mellan grannkort. Priset blev att hela
 * sortimentet bar luft för de få produkter som har omdöme eller nedsatt pris: på mobil
 * 29 px mellan specraden och priset, mot 10 px på dator.
 *
 * Här nollas reservationen och varje rutnätsrad mäts för sig. Har inget kort i raden
 * ett betyg tar betygsraden ingen plats alls; har ett kort det växer bara den raden och
 * grannen matchar. Uppmätt: luften ner till 9 px på mobil med noll rader ur linje.
 *
 * Progressiv förbättring: CSS behåller reservationerna som förval, och klassen
 * na-rows-ready (som sätts här) nollar dem. Kör inte skriptet ser sidan ut som förut.
 * JOGR
 */
(function () {
  var SLOTS = ['.na-rating-slot', '.price'];
  var timer = null;

  function grid() {
    return document.querySelectorAll('.product-grid');
  }

  function jamnaUt() {
    grid().forEach(function (g) {
      var kort = [].slice.call(g.querySelectorAll('.grid__item')).filter(function (k) {
        return k.offsetParent !== null;
      });
      if (!kort.length) return;

      // Nolla föregående utjämning innan mätning, annars mäter vi vårt eget resultat.
      kort.forEach(function (k) {
        SLOTS.forEach(function (sel) {
          var el = k.querySelector(sel);
          if (el) el.style.minHeight = '';
        });
      });
      g.classList.add('na-rows-ready');

      /* Gruppera på kortets överkant. Avrundas till närmaste 8 px: grannkort i samma
         rad kan skilja sig någon delpixel, och utan tolerans hamnade de i var sin grupp
         och jämnades aldrig ut. Radavståndet är 34 px, så två riktiga rader kan inte
         slås ihop av misstag. */
      var rader = {};
      kort.forEach(function (k) {
        var topp = Math.round((k.getBoundingClientRect().top + window.pageYOffset) / 8) * 8;
        (rader[topp] = rader[topp] || []).push(k);
      });

      Object.keys(rader).forEach(function (topp) {
        var grupp = rader[topp];
        if (grupp.length < 2) return;
        SLOTS.forEach(function (sel) {
          var el = grupp.map(function (k) { return k.querySelector(sel); }).filter(Boolean);
          if (el.length < 2) return;
          var max = 0;
          el.forEach(function (e) { max = Math.max(max, e.getBoundingClientRect().height); });
          el.forEach(function (e) { e.style.minHeight = Math.round(max) + 'px'; });
        });
      });
    });
  }

  function planera() {
    clearTimeout(timer);
    timer = setTimeout(jamnaUt, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', jamnaUt);
  } else {
    jamnaUt();
  }
  // Typsnitt och bilder kan ändra höjder efter DOMContentLoaded.
  window.addEventListener('load', planera);
  window.addEventListener('resize', planera);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(planera);

  /* Filter och sidbyten byter ut rutnätets innehåll med fetch (na-filters), och
     rekommendationssektioner renderas in i efterhand. Observera därför DOM:en. */
  if (window.MutationObserver) {
    var obs = new MutationObserver(planera);
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('#ProductGridContainer, .product-grid').forEach(function (n) {
        obs.observe(n, { childList: true, subtree: true });
      });
    });
  }
})();
